import { render } from "./Base.vue?vue&type=template&id=35f98f8c&bindings={}"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"
script.render = render

export default script